import { createFileRoute } from "@tanstack/react-router";
import { EligibilityDetail } from "@/components/EligibilityDetail";

export const Route = createFileRoute("/eligibility/express")({
  component: () => <EligibilityDetail slug="express" />,
});
